import {importSvg as Icon__small__importSvg} from '../Icon__small/Icon__small--import.js';

export var importIcon = {
  name: 'import',
  category: 'icon',
  colorable: true,
  svg: Icon__small__importSvg,
};
